// Cornice browser pulita per i mockup dei concept.
// Dicitura neutra "Anteprima progetto": nessun dominio fittizio.
export const BrowserMockup = ({ url, children, testid, contentClass = "aspect-[4/3]" }) => (
  <div
    data-testid={testid}
    className="overflow-hidden rounded-xl border border-line bg-white shadow-[0_24px_60px_-24px_rgba(11,31,51,0.28)]"
  >
    <div className="flex items-center gap-2 border-b border-line bg-mist px-4 py-2.5">
      <span className="flex gap-1.5" aria-hidden="true">
        <span className="h-2.5 w-2.5 rounded-full bg-[#E3B0A6]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#E8D5A3]" />
        <span className="h-2.5 w-2.5 rounded-full bg-[#A9CEB4]" />
      </span>
      <span className="ml-2 flex-1 truncate rounded-md border border-line bg-white px-3 py-1 text-[11px] text-steel">
        {url}
      </span>
    </div>
    <div className={`w-full overflow-hidden ${contentClass}`}>{children}</div>
  </div>
);
